import {gql} from "@apollo/client";

export const FGM_DASHBOARD_DEFINITION_FIELDS = gql`
  fragment DashboardDefinitionFields on DashboardDefinition {
    id
    created_at
    name
    ordering
    is_default_dashboard
    is_pinned
    metrics_show_section
    metrics_for_all_checks
    services_show_section
    services_num_to_show
    services_selected {
      id
    }
    services_tags {
      id
    }
    match_all_tags
    services_include_up
    services_include_down
    services_include_paused
    services_include_maintenance
    services_primary_sort
    services_secondary_sort
    services_show_uptime
    services_show_response_time
    alerts_show_section
    alerts_for_all_checks
    alerts_include_ignored
    alerts_include_resolved
    alerts_num_to_show
    charts_show_section
    charts {
      id
      view_id
      view_name
      time_range
    }
  }
`;
